import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-repair-bangalore", label: "LG Washing Machine Repair" },
  { to: "/lg-washing-machine-not-spinning", label: "LG Washing Machine Not Spinning" },
  { to: "/lg-front-load-washing-machine-service-bangalore", label: "LG Front Load Service" },
  { to: "/lg-top-load-washing-machine-service-bangalore", label: "LG Top Load Service" },
];

const LGWashingMachineService = () => {
  return (
    <LGWashingPageTemplate
      title="LG Washing Machine Service in Bangalore"
      description="Doorstep LG washing machine service in Bangalore for front load, top load, and automatic models with fast technician support."
      keywords="lg washing machine service bangalore, lg washer repair bangalore, lg service center bangalore"
      path="/lg-washing-machine-service-bangalore"
      bannerTitle="LG Washing Machine Service in Bangalore"
      intro={<>Customer Supports 24x7 offers <span style={{ fontWeight: 'bold' }}>LG washing machine service in Bangalore</span> for common breakdowns, poor washing performance, drainage issues, and maintenance needs. Our technicians handle <span style={{ fontWeight: 'bold' }}>front load</span> and <span style={{ fontWeight: 'bold' }}>top load</span> models with doorstep inspection and repair support.</>}
      highlights={[
        "Front load and top load LG washing machine support",
        "Inspection, servicing, and spare part replacement",
        "Drainage, spin, motor, and PCB fault diagnosis",
        "Doorstep technician visits across Bangalore",
      ]}
      issues={[
        "Machine not starting",
        "Spin cycle problems",
        "Water leakage or drainage issues",
        "Noise, vibration, or drum faults",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGWashingMachineService;
